// Les TRANSCRIPTIONS d'une étude, chacune avec son lien « Découper ».
//
// Une transcription importée avant la migration 047 n'a pas gardé son texte :
// elle se liste (ses verbatims existent), mais ne se découpe pas.
import { useStudySources } from '../api/queries';
import { Link } from '../router';
import { buttonClass } from '../components/ui';
import './sources.css';

export function sourcePath(projectId: string, studyId: string, sourceId: string) {
  return `/projet/${encodeURIComponent(projectId)}/etudes/${encodeURIComponent(studyId)}/transcriptions/${encodeURIComponent(sourceId)}`;
}

export function StudySources({ projectId, studyId }: { projectId: string; studyId: string }) {
  const query = useStudySources(studyId);
  const sources = query.data ?? [];
  if (sources.length === 0) return null;
  return (
    <ul className="source-list" aria-label="Transcriptions de l’étude">
      {sources.map((s) => (
        <li key={s.id} className="source-row">
          <span className="source-row-title">{s.origin_label ?? 'Transcription'}</span>
          <span className="source-row-meta">
            {new Date(s.created_at).toLocaleDateString('fr-FR')} · {s.verbatims} verbatim{s.verbatims > 1 ? 's' : ''} retenu{s.verbatims > 1 ? 's' : ''}
          </span>
          {s.readable ? (
            <Link to={sourcePath(projectId, studyId, s.id)} className={buttonClass('ghost')}>
              {s.verbatims > 0 ? 'Relire et découper' : 'Découper'}
            </Link>
          ) : (
            <span className="source-row-meta">Texte non gardé (import antérieur)</span>
          )}
        </li>
      ))}
    </ul>
  );
}
